package ui.device.detail.preview.screen

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Tab
import androidx.compose.material3.TabRow
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.device_detail__report_system_alive__title
import ssoft.frontend.generated.resources.device_detail__report_system_hourly__title
import tk.mallumo.compose.navigation.DeviceContentReportSystem
import tk.mallumo.compose.navigation.Graph
import tk.mallumo.compose.navigation.NavigationChildDeviceContentReportSystem
import tk.mallumo.compose.navigation.Node
import tk.mallumo.compose.navigation.ReportDeviceSystemUI
import tk.mallumo.compose.navigation.asBundle
import tk.mallumo.compose.navigation.navTo_ReportDeviceAliveUI
import tk.mallumo.compose.navigation.navTo_ReportDeviceSystemUI
import tools.rememberString
import ui.device.detail.preview.DevicePreviewScope
import ui.report.device.ReportDeviceArgs

@Composable
fun DevicePreviewScope.DeviceScreen05_Monitoring(nnvl: DevicePreviewScope.Wrapper) {
    val args = remember {
        ReportDeviceArgs(
            deviceId = nnvl.data.id
        ).asBundle()
    }
    var selectedTab by remember {
        mutableStateOf(0)
    }
    Column(Modifier.fillMaxSize()) {
        TabRow(selectedTab, Modifier.fillMaxWidth()) {
            Tab(
                selected = selectedTab == 0,
                onClick = {
                    selectedTab = 0
                    nav.findChildNavigation(Graph.DeviceContentReportSystem)?.also {
                        it.navTo_ReportDeviceSystemUI(args, clearTop = true)
                    }
                },
                text = { Text(Res.string.device_detail__report_system_hourly__title.rememberString()) })
            Tab(
                selected = selectedTab == 1,
                onClick = {
                    selectedTab = 1
                    nav.findChildNavigation(Graph.DeviceContentReportSystem)?.also {
                        it.navTo_ReportDeviceAliveUI(args, clearTop = true)
                    }
                },
                text = { Text(Res.string.device_detail__report_system_alive__title.rememberString()) })
        }
        Box(Modifier.fillMaxSize()) {
            NavigationChildDeviceContentReportSystem(Node.ReportDeviceSystemUI, args)
        }
    }
}
